import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function ContentPage(): JSX.Element {
  return (
    <ConfigSection
      title={"Conteúdo dinâmico (onboarding e ajuda)"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      'Modelo `AppContentBlock` existe no schema, mas não há rota de edição/publicação.',
      'Preview mobile/tablet depende de rota interna do app (ainda não exposta).'
]}
      planned={[
      'Blocos tipados (`heading`, `paragraph`, `image`, `callout`, `faq`, `checklist`, `action`).',
      'Estados draft/review/published/archived com rollback; app ignora bloco desconhecido.'
]}
    />
  );
}